<template>
  <OrderDetailSummary
    :chatbot="chatbot"
    :chatbotStatus="chatbotStatus"
    :orderDetailSummary="orderDetailSummary"
    :orderDetailPayment="orderDetailPayment"
    :orderDetailReservation="orderDetailReservation"
    :customerServiceTelephoneNumber="customerServiceTelephoneNumber"
    :onCashReceipts="openCashReceipts"
    :onReceiptSending="openReceiptSending"
    :cashReceipt="cashReceipt"
    :customerCenterLog="customerCenterLog"
    :onBmartMove="onBmartMove"
    :onChatbot="onChatbot"
  />
</template>

<script>
import axios from 'axios'
import OrderDetailSummary from '../../layouts/organisms/OrderDetailSummary/index'
import { MoveType, Action, Location } from '@/plugins/AppManager'

import { LogScreenName, LogType, LogGroup, LogEvent } from '@/plugins/AppLogManager'
import { NativeStorageKey } from '../../../../../plugins/NativeStorageManager'

export default {
  name: 'OrderDetailSummaryContainer',
  props: {
    chatbot: Boolean
  },
  components: { OrderDetailSummary },
  computed: {
    orderDetailSummary() {
      return this.$store.getters['myOrderHistoryDetailV2/orderDetail'].summary
    },
    orderDetailPayment() {
      return this.$store.getters['myOrderHistoryDetailV2/orderDetail'].payment
    },
    orderDetailReservation() {
      return this.$store.getters['myOrderHistoryDetailV2/orderDetail'].orderReservation
    },
    customerServiceTelephoneNumber() {
      return this.$store.getters['myOrderHistoryDetailV2/customerServiceTelephoneNumber']
    },
    cashReceipt() {
      return this.$store.getters['myOrderHistoryDetailV2/cashReceipt'][0]
    },
    chatbotStatus() {
      return this.$store.getters['myOrderHistoryDetailV2/chatbotStatus']
    }
  },
  methods: {
    onChatbot(orderId) {
      const { shopId } = this.$store.getters['myOrderHistoryDetailV2/orderDetail'].summary

      if (this.chatbotStatus.isClosedCenter()) {
        this.$store.dispatch('modal/open', {
          type: 'Check',
          message: this.chatbotStatus.closedPopupMessage(),
          onOK: async () => {
            this.$store.dispatch('modal/close')
          },
          onCancel: async () => {}
        })
      } else {
        window.location.replace(`${process.env.VUE_APP_GO_TO_CHATBOT}${orderId}`)
      }

      this.$appLogManager.post({
        screenName: LogScreenName.MARKET_ORD_DET,
        type: LogType.CLICK,
        group: LogGroup.LIVE_CHAT,
        event: LogEvent.LIVE_CHAT_CENTER,
        params: {
          OrdNo: String(orderId),
          ShopNo: String(shopId)
        }
      })
    },
    async onBmartMove() {
      try {
        const result = await this.$store.dispatch('myOrderHistoryDetailV2/checkServiceArea')

        const hasBmartIcon = result.success

        if (hasBmartIcon) {
          this.$appManager.move(Location.HISTORY_TO_SHOP, this.$store.getters.isAndroid, MoveType.REPLACE)
        } else {
          this.$store.dispatch('modal/open', {
            type: 'NotServiceArea',
            message: '',
            onOK: async () => {
              this.$appManager.move(Location.HOME, this.$store.getters.isAndroid, MoveType.REPLACE)
              this.$store.dispatch('modal/close')
            },
            onCancel: async () => {
              this.$store.dispatch('modal/close')
            }
          })
        }
      } catch (err) {
        alert('인터넷 연결상태를 확인해주세요.')
        console.log(JSON.stringify(err))
      }
    },

    customerCenterLog() {
      const { orderId, shopId } = this.$store.getters['myOrderHistoryDetailV2/orderDetail'].summary

      const params = {
        OrdNo: String(orderId),
        ShopNo: String(shopId)
      }

      // M5-1
      this.$appLogManager.post({
        screenName: LogScreenName.MARKET_ORD_DET,
        type: LogType.CLICK,
        group: LogGroup.CALL,
        event: LogEvent.CENTER_CALL,
        params
      })
    },
    openCashReceipts(paymentKey) {
      const { alert, alertMessage } = this.cashReceipt

      if (alert) {
        this.$store.dispatch('modal/open', {
          type: 'Check',
          message: alertMessage,
          onOK: () => {
            this.$store.dispatch('modal/close')
          },
          onCancel: () => {
            this.$store.dispatch('modal/close')
          }
        })

        return
      }

      // // TODO implement 현금영수증 보기; 현재는 현금성 결제 미지원
      // this.$store.dispatch('modal/open', {
      //   type: 'CashReceipt',
      //   message: '현금영수증 보기',
      //   renderType: 'full-slide-up',
      //   params: {
      //     orderId,
      //     cashReceipt: this.cashReceipt
      //   },
      //   onOK: () => {
      //     this.$store.dispatch('modal/close')
      //   },
      //   onCancel: () => {}
      // })

      const CASH_RECEIPT_APPSCHEME = `${process.env.VUE_APP_DEEP_LINK_PROTOCOL}./webview?webview_url=${encodeURI(
        `${
          process.env.VUE_APP_APP_LOG_ENV === 'RELEASE'
            ? 'https://market-order.baemin.com'
            : 'http://market-order-front.beta.baemin.com'
        }/my/order/cash-receipt/${paymentKey}`
      )}&webview_type=no_navigation&webview_page=pg`

      window.location.href = CASH_RECEIPT_APPSCHEME
    },

    openReceiptSending(paymentKey) {
      if (!this.orderDetailSummary.isBaeminPayReceiptIssued()) {
        this.$store.dispatch('modal/open', {
          type: 'Check',
          message: this.orderDetailSummary.baeminPayReceiptIssuedText(),
          onOK: async () => {
            this.$store.dispatch('modal/close')
          },
          onCancel: async () => {}
        })

        return
      }
      // TODO 영수증 받기 check src/components/my/order/MoveReceiptSending.vue:1
      this.$appManager.moveSimple(`/my/order/send-receipt/${paymentKey}`, MoveType.PUSH)
    }
  }
}
</script>
